import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Title} from '../../../../components/title/title';
import {TranslatePipe} from '@ngx-translate/core';
import {TabItem, TabMenu} from '../../../../components/tab-menu/tab-menu';
import {RouterOutlet} from '@angular/router';
import {RouteUri} from '../../../../constants/route-uri';

@Component({
  selector: 'elcia-products-summary',
  imports: [
    Title,
    TranslatePipe,
    TabMenu,
    RouterOutlet,
  ],
  templateUrl: './products-summary.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsSummary {

  protected readonly items: TabItem[] = [
    {
      icon: 'tag',
      label: 'entity.products',
      route: RouteUri.PRODUCTS_LIST,
    },
    {
      icon: 'file',
      label: 'entity.licence-plans',
      route: RouteUri.LICENCE_PLANS,
    },
    {
      icon: 'columns',
      label: 'entity.features',
      route: RouteUri.FEATURES,
    },
    {
      icon: 'box',
      label: 'entity.plugins',
      route: RouteUri.PLUGINS,
    },
  ];

}
